import { useHistory } from 'react-router-dom';

import { Typography } from '@julo-ui/react';
import { ArrowLeft, HelpIcon } from '@new-components/shapes';

import { subHeaderContainer } from './styles';
import { NT90 } from '@julofinance/color-token';

interface NewSubHeaderProps {
  title: string;
  onClickBack?: () => void;
  showHelp?: boolean;
}

const NewSubHeader = ({
  title,
  onClickBack,
  showHelp = false,
}: NewSubHeaderProps) => {
  const history = useHistory();
  return (
    <div className={subHeaderContainer}>
      <div className='nav-content'>
        <ArrowLeft
          onClick={onClickBack}
          data-testid='btnBackNav'
          iconColor={NT90}
        />
        <Typography
          type='heading'
          headingType={6}
          bold
          fontSize='18px'
          color={NT90}
        >
          {title}
        </Typography>
      </div>
      {showHelp && (
        <div className='help-ticker' onClick={() => history.push('/help')}>
          <HelpIcon />
          <span>Pusat Bantuan</span>
        </div>
      )}
    </div>
  );
};

export default NewSubHeader;
